import styled from "styled-components";

export const SubtitleBodyContent = styled.div`
  padding: ${(props) => props.theme.spacing?.xxl ?? "24px"}; /* 6x */
`;
